import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { connectSocket, SocketRoom } from 'services/socket'
import { logApiError } from 'services/apiError'
import DateInput from 'components/Inputs/DateInput'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import CashRegister from 'components/CashRegister'
import { DateTime } from 'luxon'
import { ListContainer, Row, InfoText } from '../styles'

export default function CashRegisterHistory () {
  const token = AuthService.getToken ()
  const businessId = AuthService.getBusinessId ()
  const [loading, setLoading] = useState (false)
  const [date, setDate] = useState ('') 
  const [cashRegisters, setCashRegisters] = useState ([])
  const [bankAccounts, setBanksAccounts] = useState ([])
  const [cardFlags, setCardFlags] = useState ([])

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    if (date) getData ()
  }, [date])

  useEffect (() => {
    const socket = connectSocket ({
      token, rooms: [SocketRoom.business (businessId)]
    })

    socket.on (`${businessId}_cash_register_opened`, handleEditCashRegister)
    socket.on (`${businessId}_cash_register_closed`, handleEditCashRegister)

    return () => {socket.disconnect ()}
    // Ver CashRegisters: reconectava a cada evento.
  }, [businessId, token])

  const getData = async () => {
    try {
      setLoading (true)

      const { data: cashRegisters } = await cutileiApi.get (
        `/cash_registers?business_id=${businessId}&date=${date}`, requestConfig
      )

      const { data: bankAccounts } = await cutileiApi.get (
        `/businesses/${businessId}/bank_accounts`, requestConfig
      )

      const { data: cardFlags } = await cutileiApi.get (
        '/card_flags', requestConfig
      )
  
      setCashRegisters (cashRegisters)
      setBanksAccounts (bankAccounts)
      setCardFlags (cardFlags)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  const compareCashRegisters = (a, b) => (
    DateTime.fromISO (a.created_at).toMillis () - DateTime.fromISO (b.created_at).toMillis ()
  )

  const handleEditCashRegister = cashRegister => {
    setCashRegisters (prevCashRegisters => [
      ...prevCashRegisters.filter (cr => cr.id !== cashRegister.id), cashRegister
    ].sort (compareCashRegisters))
  }

  return (
    <ListContainer>
      <Row style={{marginBottom: 25}}>
        <DateInput
          placeholder='Data'
          value={date ? DateTime.fromISO (date) : null}
          onChange={setDate}
          style={{width: 180}}
        />
      </Row>
      {loading ? <Loading/> : (
        cashRegisters.length > 0 ? cashRegisters.map (cashRegister => (
          <CashRegister
            key={cashRegister.id}
            data={cashRegister}
            cardFlags={cardFlags}
            bankAccounts={bankAccounts}
            onCloseCashRegister={handleEditCashRegister}
            onReopenCashRegister={handleEditCashRegister}
          />
        )) : date && (
          <Row>
            <InfoText>Nenhum caixa encontrado</InfoText>
          </Row>
        )
      )}
    </ListContainer>
  )
}
